import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { Cotizacion, TipoCotizacion, EstadoCotizacion } from '../../../interfaces/cotizacion';
import { FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Entidad, TipoEntidad } from '../../../interfaces/entidad';
import { CotizacionService } from '../../../providers/cotizacion.service';
import { ProspectoService } from '../../../providers/prospecto.service';
import { ListarItemsComponent } from '../items/listar-items/listar-items.component';
import { MatCheckboxChange, MatSelect, MatAutocomplete, MatDialog } from '@angular/material';
import { Item } from '../../../interfaces/item';
import { Producto } from '../../../interfaces/producto';
import { Accesorio } from '../../../interfaces/accesorio';
import { Usuario, TipoUsuario } from '../../../interfaces/usuario';
import { UsuarioService } from '../../../providers/usuario.service';
import { TipoProducto, TipoProductoCategoria } from '../../../interfaces/tipo-producto';
import { TipoGarantia } from '../../../interfaces/tipo-garantia';
import { ClienteService } from '../../../providers/cliente.service';
import { EntidadService } from '../../../providers/entidad.service';
import { WMatTimePickerComponent } from '../../../components/timer/time-control';
import { ReplaySubject, Observable } from 'rxjs';
import { TipoPago } from '../../../interfaces/tipo-pago';
import { TipoMoneda } from '../../../interfaces/tipo-moneda';
import { TipoValidez } from '../../../interfaces/tipo-validez';
import { TipoGarantiaService } from '../../../providers/tipo-garantia.service';
import { TipoValidezService } from '../../../providers/tipo-validez.service';
import { TipoImpuestoService } from '../../../providers/tipo-impuesto.service';
import { TipoMonedaService } from '../../../providers/tipo-moneda.service';
import { TipoPagoService } from '../../../providers/tipo-pago.service';
import { startWith, map } from 'rxjs/operators';
import { AuthenticationService } from '../../../providers/auth.service';
import { AutorizadorDialog } from '../../../components/autorizador/autorizador.component';
import { TipoPlazo } from '../../../interfaces/tipo-plazo';
import { Telefono } from '../../../components/telefono/telefono.component';
import { TipoEntregaService } from '../../../providers/tipo-entrega.service';
import { TipoEntrega } from '../../../interfaces/tipo-entrega';
import { Competidor } from '../../../interfaces/competidor';
import { CompetidorService } from '../../../providers/competidor.service';
import { TipoImpuesto } from '../../../interfaces/tipo-impuesto';
import { TipoCondicion } from '../../../interfaces/tipo-condicion';
import { TipoCondicionService } from '../../../providers/tipo-condicion.service';
import { PropuestasService } from '../../../providers/propuestas.service';
import { Propuesta } from '../../../interfaces/propuesta';

export function verificarEntidadValidatorFn(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors => {
    // si no hay un valor es requerido
    if (!control.value) {
      return <ValidationErrors>{
        'required': true // la entidad es requerida
      };
    } else {
      // si hay un valor, debe tener un IdEntidad ingresado
      let entidad = <Entidad>control.value;
      if (!entidad.IdEntidad) {
        return <ValidationErrors>{
          'required': true // la entidad es requerida
        };
      }
    }

    return null;
  }
}

@Component({
  selector: 'app-cotizacion',
  templateUrl: './cotizacion.component.html',
  styleUrls: ['./cotizacion.component.scss']
})
export class CotizacionComponent implements OnInit {
  @Input() copia: boolean = false;
  @Input() IdCotizacion?: number | string;
  @Input() entidad?: Entidad;
  @Input() propuesta?: any;

  cotizacion: Cotizacion;
  panelOpenState;
  IdEstadoAnterior: number | string; // estado de la cotización al momento de entrar al edit
  entidades: Entidad[] = [];
  cargandoEntidades: boolean = false;
  cargandoPropuestas: boolean = false;
  propuestaEnabled: boolean = false;
  cotizacionTipos: TipoCotizacion[] = [];
  cargandoTipos: boolean = false;
  cotizacionTiposEntrega: TipoEntrega[] = [];
  cargandoTiposEntrega: boolean = false;
  cotizacionResponsables: Usuario[] = [];
  cargandoUsuarios = false;
  cotizacionEstados: EstadoCotizacion[] = [];
  cargandoEstados = false;

  cotizacionTiposGarantia: TipoGarantia[] = [];
  cargandoTiposGarantia = false;
  cotizacionTiposPago: TipoPago[] = [];
  cargandoTiposPago = false;
  cotizacionTiposImpuesto: TipoImpuesto[] = [];
  cargandoTiposImpuesto = false;
  cotizacionTiposMoneda: TipoMoneda[] = [];
  cargandoTiposMoneda = false;
  cotizacionTiposValidez: TipoValidez[] = [];
  cargandoTiposValidez = false;
  cotizacionCompetidores: Competidor[] = [];
  cargandoCompetidores = false;
  cotizacionPropuestas;

  condiciones: TipoCondicion[] = [];
  cargandoCondiciones = false;
  @Output() onCotizacionInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario
  inputEntidadPlaceholder = '';

  @ViewChild('listadoItems') listadoItems: ListarItemsComponent;
  @ViewChild('horaVencimientoInput') horaVencimientoInput: WMatTimePickerComponent;

  // para el select con buscador de entidades
  public entidadesFiltroCtrl: FormControl = new FormControl();
  public entidadesFiltradas: ReplaySubject<Entidad[]> = new ReplaySubject<Entidad[]>(1);
  public propuestasFiltroCtrl: FormControl = new FormControl();
  public propuestasFiltradas: ReplaySubject<Propuesta[]> = new ReplaySubject<Propuesta[]>(1);
  @ViewChild('selectEntidad') selectEntidad: MatSelect;
  @ViewChild('selectPropuesta') selectPropuesta: MatSelect;
  //@ViewChild('selectPropuesta') selectPropuesta: MatSelect;

  // para el autocomplete del campo obra
  @ViewChild(MatAutocomplete) obraAuto: MatAutocomplete;
  obras: String[] = [];
  cargandoObras: boolean = false;
  obraFormControl: FormControl;
  obrasFiltradas: Observable<any[]>;

  entidadFormControl = new FormControl('', []);
  propuestaFormControl = new FormControl('', []);
  tipoCotizacionFormControl = new FormControl('', [
    Validators.required
  ]);
  estadoFormControl = new FormControl('', [
    Validators.required
  ]);

  estadoDescripciones: String[] = [];
  cargandoEstadoDescripciones: boolean = false;
  estadoMotivoFormControl: FormControl;
  estadoDescripcionesFiltradas: Observable<any[]>;
  idPropuesta: number;

  constructor(
    public cotizacionService: CotizacionService,
    private prospectoService: ProspectoService,
    private entidadService: EntidadService,
    private usuarioService: UsuarioService,
    private condicionService: TipoCondicionService,
    private garantiaService: TipoGarantiaService,
    private competidorService: CompetidorService,
    private pagoService: TipoPagoService,
    private monedaService: TipoMonedaService,
    private impuestoService: TipoImpuestoService,
    private validezService: TipoValidezService,
    private entregaService: TipoEntregaService,
    private clienteService: ClienteService,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService,
    public propuestaService: PropuestasService
  ) {
    // la entidad tiene un validador especial
    this.entidadFormControl.setValidators([
      verificarEntidadValidatorFn()
    ]);

    // Filtro a medida que van escribiendo
    this.obraFormControl = new FormControl();
    this.obrasFiltradas = this.obraFormControl.valueChanges
      .pipe(
        startWith(''),
        map((obraBuscada: string) => obraBuscada ? this.obras.filter(obraDescripcion =>
          obraDescripcion.toLowerCase().indexOf(obraBuscada.toLowerCase()) === 0) : this.obras.slice())
      );

    // Filtro a medida que van escribiendo
    this.estadoMotivoFormControl = new FormControl();
    this.estadoDescripcionesFiltradas = this.estadoMotivoFormControl.valueChanges
      .pipe(
        startWith(''),
        map((estadoDescripcionBuscado: string) => estadoDescripcionBuscado ? this.estadoDescripciones.filter(estadoDescripcion =>
          estadoDescripcion.toLowerCase().indexOf(estadoDescripcionBuscado.toLowerCase()) === 0) : this.estadoDescripciones.slice())
      );
  }

  ngOnInit() {
    this.cotizacion = new Cotizacion();
    if (this.propuesta) {
      this.cotizacion.propuesta = this.propuesta.IdPropuesta;
    } else {
      this.traerPropuestas();
    }
    if (this.entidad && this.entidad.IdEntidad != null) { // si recibo una entidad la cotización debe ser asignada a la entidad recibida
      this.cotizacion.entidad.IdEntidad = this.entidad.IdEntidad;
      this.entidadFormControl.disable({ onlySelf: true }); // no se puede cambiar la entidad seleccionada      
      this.entidadFormControl.setValue(this.cotizacion.entidad);

      if (this.entidad.tipoEntidad) {
        if (this.entidad.tipoEntidad.IdTipo == 1) {
          this.inputEntidadPlaceholder = 'Prospecto';
          this.traerProspectos(this.entidad.IdEntidad);
        } else if (this.entidad.tipoEntidad.IdTipo == 2) {
          this.inputEntidadPlaceholder = 'Cliente';
          this.traerClientes(this.entidad.IdEntidad);
        }
      }
    } else {
      this.inputEntidadPlaceholder = 'Prospecto/Cliente';
      this.traerEntidades();
    }

    if (this.IdCotizacion != null) { // si recibo un id solicitar los datos
      if (!this.copia) {
        // si no es una copia y recibo un IdCotización, es una edición
        // el prospecto/cliente no es editable
        this.entidadFormControl.disable({ onlySelf: true }); // no se puede cambiar la entidad seleccionada  
      }

      this.formState.emit({ cargando: true });
      this.cotizacionService.getCotizaciones(
        {
          page: null,
          pageSize: null
        },
        {
          sort: null,
          order: null
        },
        {
          IdCotizacion: this.IdCotizacion
        }
      ).subscribe(
        respuesta => {
          if (respuesta && respuesta.data && respuesta.estado == 1) {
            var cotizacion = respuesta.data.cotizaciones[0];
            if (cotizacion) {

              this.cotizacion = new Cotizacion(
                cotizacion.IdCotizacion,
                cotizacion.fechaAlta,
                <Entidad>{
                  IdEntidad: cotizacion.entidad.id,
                  razonSocial: cotizacion.entidad.razonSocial,
                  tipoEntidad: <TipoEntidad>{
                    IdTipo: cotizacion.entidad.tipo.IdTipo,
                    descripcion: cotizacion.entidad.tipo.TipoDescripcion
                  }
                },
                <TipoCotizacion>{
                  IdTipo: cotizacion.tipo.id,
                  descripcion: cotizacion.tipo.descripcion
                },
                cotizacion.detalle,
                <Item[]>[],
                new TipoEntrega(
                  cotizacion.tipoEntrega.id,
                  cotizacion.tipoEntrega.descripcion
                ),
                <EstadoCotizacion>{
                  IdEstado: cotizacion.estado.id,
                  descripcion: cotizacion.estado.descripcion
                },
                cotizacion.total,
                <TipoGarantia>{
                  id: cotizacion.garantia.id,
                  descripcion: cotizacion.garantia.descripcion
                },
                Object.assign([], cotizacion.condiciones),
                cotizacion.obra,
                cotizacion.fechaVencimiento,
                cotizacion.horaVencimiento ? cotizacion.horaVencimiento : null, // solo importa la hora
                cotizacion.estadoMotivo,
                cotizacion.destinoEntrega,
                new TipoMoneda(
                  cotizacion.moneda.id,
                  cotizacion.moneda.descripcion,
                  cotizacion.moneda.subfijo
                ),
                new TipoPago(
                  cotizacion.pago.id,
                  cotizacion.pago.descripcion
                ),
                new TipoValidez(
                  cotizacion.validez.id,
                  cotizacion.validez.descripcion
                ),
                Object.assign([], cotizacion.tipoImpuesto),
                cotizacion.fechaApertura,
                !!+cotizacion.editable,
                cotizacion.created_by,
                cotizacion.numero,
                cotizacion.fechaHoraModificacion,
                new Competidor(
                  cotizacion.competidor.id,
                  cotizacion.competidor.descripcion
                ),
                cotizacion.vecesModificada,
                new Usuario(
                  cotizacion.responsable.IdUsuario,
                  cotizacion.responsable.usuario,
                  null,
                  null,
                  null,
                  cotizacion.responsable.nombre,
                  cotizacion.responsable.apellido
                ),
                !!+cotizacion.alMenosUnArchivo,
                cotizacion.observaciones_venta,
                cotizacion.motivo_venta_rechazada,
                cotizacion.propuesta
              );

              // estado antes de aplicar cambios a la cotización
              this.IdEstadoAnterior = this.cotizacion.estado.IdEstado;

              this.tipoCotizacionFormControl.setValue(this.cotizacion.tipoCotizacion);
              this.estadoFormControl.setValue(this.cotizacion.estado);
              this.traerItems(+this.cotizacion.IdCotizacion); // traer sus items

              // si estamos copiando una cotización
              if (this.copia) {
                // el estado se debe seleccionar por el usuario
                this.cotizacion.estado = null;
                this.estadoFormControl.setValue(null);
                this.estadoFormControl.updateValueAndValidity();

                // el IdCotizacion original se borra (se generará uno nuevo en el servidor)
                delete this.cotizacion['IdCotizacion'];
                this.IdCotizacion = null;
                this.cotizacion.numero = null;
              }

              this.validarNumeroDisponible();

              this.formState.emit({ // datos encontrados
                estado: 1,
                mensaje: respuesta.mensaje,
                cargando: false
              });
            } else {
              this.formState.emit({ // error al buscar datos
                estado: 3,
                mensaje: 'No se encontraron los datos buscados',
                cargando: false
              });
            }
          }
        },
        error => {
          this.formState.emit({ // error con el servidor
            estado: 2,
            mensaje: error,
            cargando: false
          });
        }
      );
    }
    this.traerResponsables();
    this.traerEstados();
    this.traerGarantias();
    this.traerCompetidores();
    this.traerPagos();
    this.traerMonedas();
    this.traerImpuestos();
    this.traerValideces();
    this.traerCondiciones();
    this.traerTiposCotizacion();
    this.traerObras();
    this.traerEstadoDescripciones();
    this.traerEntregas();

    // cuando cambia el valor del buscador, filtramos
    this.entidadesFiltroCtrl.valueChanges.subscribe(() => {
      this.filtrarEntidades();
    });
    // cuando cambia el valor del buscador, filtramos
    this.propuestasFiltroCtrl.valueChanges.subscribe(() => {
      this.filtrarPropuestas();
    });

    this.propuestaFormControl.valueChanges.subscribe(() => {
      this.entidades = [];
      if(this.propuestaFormControl.value != null){
        this.propuestaFormControl.value.entidades.forEach((prospecto: any) => {
          this.entidades.push(<Entidad>{
            IdEntidad: prospecto.IdEntidad,
            razonSocial: prospecto.EntidadRazonSocial + ' ' + (this.inputEntidadPlaceholder == 'Prospecto/Cliente' ? '(' + prospecto.tipo.TipoEntidadDesc + ')' : ''),
            tipoEntidad: <TipoEntidad>{
              IdTipo: prospecto.tipo.IdTipoEntidad,
              descripcion: prospecto.tipo.TipoEntidadDesc
            }
          });
        });
        this.filtrarEntidades();
        this.cotizacion.propuesta = this.propuestaFormControl.value.IdPropuesta;
      }
    });

    this.entidadFormControl.valueChanges.subscribe(() => {
      if(this.entidadFormControl.value.IdEntidad != "" && this.propuestaFormControl.value == null){
        this.propuestaEnabled = true;
      }
    });

    // le decimos al array con filtro como tiene que comparar
    this.entidadesFiltradas.subscribe(
      () => {
        this.selectEntidad.compareWith = (a: Entidad, b: Entidad) => {
          if (a && b) {
            return a.IdEntidad == b.IdEntidad;
          }

          return false;
        }
      }
    );
    this.propuestasFiltradas.subscribe(
      () => {
        this.selectPropuesta.compareWith = (a, b) => {
          if (a && b) {
            return a.IdPropuesta == b.IdPropuesta;
          }

          return false;
        }
      }
    );
  }

  /**
   * Función que sabe como filtrar las entidades
   */
  private filtrarEntidades() {
    if (!this.entidades) {
      return;
    }

    // get the search keyword
    let search = this.entidadesFiltroCtrl.value;
    if (!search) {
      this.entidadesFiltradas.next(this.entidades.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // filter the banks
    this.entidadesFiltradas.next(
      this.entidades.filter(entidad => {
        return (entidad.razonSocial.toLowerCase().indexOf(search) > -1);
      })
    );
  }
  limpiarFiltroEntidad(){
    this.traerEntidades();
  }
  private filtrarPropuestas() {
    if (!this.cotizacionPropuestas) {
      return;
    }

    // get the search keyword
    let search = this.propuestasFiltroCtrl.value;
    if (!search) {
      this.propuestasFiltradas.next(this.cotizacionPropuestas.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // filter the banks
    this.propuestasFiltradas.next(
      this.cotizacionPropuestas.filter(cotizacionPropuestas => {
        return (cotizacionPropuestas.PropuestaNombre.toLowerCase().indexOf(search) > -1);
      })
    );
  }

  traerEntidades(): void {
    this.entidades = [];
    this.cargandoEntidades = true;
    this.entidadService.getEntidades(
      {
        page: 0,
        pageSize: 200
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.entidades) {
          respuesta.data.entidades.forEach((prospecto: any) => {
            this.entidades.push(<Entidad>{
              IdEntidad: prospecto.id,
              razonSocial: prospecto.razonSocial + ' ' + (this.inputEntidadPlaceholder == 'Prospecto/Cliente' ? '(' + prospecto.tipo.TipoDescripcion + ')' : ''),
              tipoEntidad: <TipoEntidad>{
                IdTipo: prospecto.tipo.IdTipo,
                descripcion: prospecto.tipo.TipoDescripcion
              }
            });
          });

          // actualizar opciones del filtro
          this.filtrarEntidades();
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'La cotización no podrá ser asignada'
          });
        }

        this.cargandoEntidades = false;
      },
      error => {
        this.cargandoEntidades = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );
  }
  traerPropuestas(): void {
    this.cotizacionPropuestas = [];
    this.cargandoPropuestas = true;
    this.propuestaService.getPropuestas(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'IdPropuesta',
        order: 'asc'
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          this.cotizacionPropuestas = respuesta.data;
        }else{
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'La cotización no podrá ser asignada'
          });
        }
        this.filtrarPropuestas();
        this.cargandoPropuestas = false;
      },
      error => {
        this.cargandoPropuestas = false;

      }
    );
  }
  traerObras(): void {
    this.obras = <string[]>[];
    this.cargandoObras = true;
    this.cotizacionService.getObras().subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          respuesta.data.forEach(obra => {
            if (obra.obra) {
              this.obras.push(obra.obra);
            }
          });

          this.obraFormControl.updateValueAndValidity();
          this.cargandoObras = false;
        }
      },
      () => {
        this.cargandoObras = false;
      }
    );
  }

  traerEstadoDescripciones(): void {
    this.estadoDescripciones = <string[]>[];
    this.cargandoEstadoDescripciones = true;
    this.cotizacionService.getEstadoDescripciones().subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          respuesta.data.forEach(estadoDescripcion => {
            if (estadoDescripcion.estadoDescripcion) {
              this.estadoDescripciones.push(estadoDescripcion.estadoDescripcion);
            }
          });

          this.estadoMotivoFormControl.updateValueAndValidity();
          this.cargandoEstadoDescripciones = false;
        }
      },
      () => {
        this.cargandoEstadoDescripciones = false;
      }
    );
  }

  traerTiposCotizacion(): void {
    this.cotizacionTipos = [];
    this.cargandoTipos = true;
    this.cotizacionService.getTiposCotizacion().subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.tiposCotizacion) {
          respuesta.data.tiposCotizacion.forEach(tipoCotizacion => {
            this.cotizacionTipos.push(<TipoCotizacion>{
              IdTipo: tipoCotizacion.IdTipoCoti,
              descripcion: tipoCotizacion.TipoCotiDesc
            });
          });
        }
      },
      () => {
        this.cargandoTipos = false;
      },
      () => {
        this.cargandoTipos = false;
      }
    );
  }

  traerProspectos(IdProspecto: number | string): void {
    this.entidades = [];
    this.cargandoEntidades = true;
    this.prospectoService.getProspectos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        IdEntidad: IdProspecto,
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.entidades) {
          respuesta.data.entidades.forEach((prospecto: any) => {
            this.entidades.push(<Entidad>{
              IdEntidad: prospecto.id,
              razonSocial: prospecto.razonSocial,
              tipoEntidad: <TipoEntidad>{
                IdTipo: prospecto.tipo.IdTipo,
                descripcion: prospecto.tipo.TipoDescripcion
              }
            });
          });

          // actualizar filtros del listado de entidades
          this.filtrarEntidades();
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'La cotización no podrá ser asignada'
          });
        }

        this.cargandoEntidades = false;
      },
      error => {
        this.cargandoEntidades = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );
  }

  traerClientes(IdCliente: number | string): void {
    this.entidades = [];
    this.cargandoEntidades = true;
    this.clienteService.getClientes(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        IdEntidad: IdCliente,
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.entidades) {
          respuesta.data.entidades.forEach((prospecto: any) => {
            this.entidades.push(<Entidad>{
              IdEntidad: prospecto.id,
              razonSocial: prospecto.razonSocial,
              tipoEntidad: <TipoEntidad>{
                IdTipo: prospecto.tipo.IdTipo,
                descripcion: prospecto.tipo.TipoDescripcion
              }
            });
          });

          // actualizar filtros del listado de entidades
          this.filtrarEntidades();
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'La cotización no podrá ser asignada'
          });
        }

        this.cargandoEntidades = false;
      },
      error => {
        this.cargandoEntidades = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );
  }

  traerItems(IdCotizacion: number): void {
    if (IdCotizacion) { // si hay un ID
      this.cotizacion.items = [];
      this.listadoItems.setCargando(true);
      this.cotizacionService.getCotizacionItems(
        {
          page: null,
          pageSize: null
        },
        {
          sort: 'fechaAlta',
          order: 'asc'
        },
        {
          IdCotizacion: IdCotizacion
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data && respuesta.data.items) {
            respuesta.data.items.forEach(item => {
              this.cotizacion.items.push(
                new Item(
                  item.IdItem,
                  <Producto>{
                    IdProducto: item.producto.id,
                    descripcion: item.producto.descripcion,
                    caracteristicas: item.producto.caracteristicas,
                    tipo: <TipoProducto>{
                      id: item.producto.tipo.id,
                      descripcion: item.producto.tipo.descripcion,
                      categoria: new TipoProductoCategoria(
                        item.producto.tipo.cat.id,
                        item.producto.tipo.cat.desc
                      )
                    }
                  },
                  item.cantidad,
                  item.precioUnitario,
                  item.label,
                  item.customDescripcion,
                  <Accesorio[]>[],
                  !!+item.especial,
                  !!+item.productoPrecioIncluido,
                  new TipoPlazo(
                    item.plazo.id,
                    item.plazo.descripcion
                  )
                )
              );

              var indexLastItem = this.cotizacion.items.length - 1;
              item.accesorios.forEach(accesorio => {
                this.cotizacion.items[indexLastItem].accesorios.push(<Accesorio>{
                  IdAccesorio: accesorio.id,
                  descripcion: accesorio.descripcion,
                  importeAsignado: accesorio.importeAsignado,
                  precioIncluido: !!+accesorio.precioIncluido,
                  precioDescripcion: accesorio.precioDescripcion,
                  cantidad: accesorio.cantidad
                });
              });
            });

            this.listadoItems.setItems(this.cotizacion.items);
          }

          this.listadoItems.setCargando(false);
        },
        () => {
          this.listadoItems.setCargando(false);
        }
      );
    }
  }

  traerResponsables(): void {
    this.cotizacionResponsables = [];
    this.cargandoUsuarios = true;
    this.usuarioService.getUsuarios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'nombre',
        order: null
      },
      {
        generico: null
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.usuarios) {
          respuesta.data.usuarios.forEach((usuario) => {
            this.cotizacionResponsables.push(
              new Usuario(
                usuario.id,
                usuario.usuario,
                usuario.email,
                <TipoUsuario>{
                  id: usuario.tipoUsuario.id,
                  descripcion: usuario.tipoUsuario.descripcion
                },
                null,
                usuario.nombre,
                usuario.apellido,
                new Telefono(usuario.telefono.pais, usuario.telefono.area, usuario.telefono.numero),
                +usuario.estado,
                usuario.puesto,
                !!+usuario.editable,
                !!+usuario.eliminable
              )
            );
          });
        }

        this.cargandoUsuarios = false;
      },
      error => {
        this.cargandoUsuarios = false;
      }
    );
  }

  traerEstados(): void {
    let filtros = {
      generico: ''
    };
    if (this.IdCotizacion != null) {
      filtros['modificando_cotizacion_id'] = this.IdCotizacion;
    }

    this.cotizacionEstados = [];
    this.cargandoEstados = true;
    this.cotizacionService.getEstadosCotizacion(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        sortOrder: null
      },
      filtros
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.estados) {
          respuesta.data.estados.forEach((estado) => {
            this.cotizacionEstados.push(<EstadoCotizacion>{
              IdEstado: estado.id,
              descripcion: estado.descripcion
            });
          });
        }

        this.cargandoEstados = false;
      },
      () => {
        this.cargandoEstados = false;
      }
    );
  }

  traerEntregas(): void {
    this.cotizacionTiposEntrega = [];
    this.cargandoTiposEntrega = true;
    this.entregaService.getTiposEntrega(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.entregas) {
          respuesta.data.entregas.forEach((entrega) => {
            this.cotizacionTiposEntrega.push(new TipoEntrega(
              entrega.id,
              entrega.descripcion
            ));
          });
        }

        this.cargandoTiposEntrega = false;
      },
      () => {
        this.cargandoTiposEntrega = false;
      }
    );
  }

  traerGarantias(): void {
    this.cotizacionTiposGarantia = [];
    this.cargandoTiposGarantia = true;
    this.garantiaService.getTiposGarantia(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.garantias) {
          respuesta.data.garantias.forEach((garantia) => {
            this.cotizacionTiposGarantia.push(<TipoGarantia>{
              id: garantia.id,
              descripcion: garantia.descripcion
            });
          });
        }

        this.cargandoTiposGarantia = false;
      },
      () => {
        this.cargandoTiposGarantia = false;
      }
    );
  }

  traerCompetidores(): void {
    this.cotizacionCompetidores = [];
    this.cargandoCompetidores = true;
    this.competidorService.getCompetidores(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.competidores) {
          respuesta.data.competidores.forEach((competidor) => {
            this.cotizacionCompetidores.push(new Competidor(
              competidor.id,
              competidor.descripcion
            ));
          });
        }

        this.cargandoCompetidores = false;
      },
      () => {
        this.cargandoCompetidores = false;
      }
    );
  }


  traerPagos(): void {
    this.cotizacionTiposPago = [];
    this.cargandoTiposPago = true;
    this.pagoService.getTiposPago(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.pagos) {
          respuesta.data.pagos.forEach((pago) => {
            this.cotizacionTiposPago.push(<TipoPago>{
              id: pago.id,
              descripcion: pago.descripcion
            });
          });
        }

        this.cargandoTiposPago = false;
      },
      () => {
        this.cargandoTiposPago = false;
      }
    );
  }

  traerMonedas(): void {
    this.cotizacionTiposMoneda = [];
    this.cargandoTiposMoneda = true;
    this.monedaService.getTiposMoneda(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.monedas) {
          respuesta.data.monedas.forEach((moneda) => {
            this.cotizacionTiposMoneda.push(<TipoMoneda>{
              id: moneda.id,
              descripcion: moneda.descripcion
            });
          });
        }

        this.cargandoTiposMoneda = false;
      },
      () => {
        this.cargandoTiposMoneda = false;
      }
    );
  }

  traerValideces(): void {
    this.cotizacionTiposValidez = [];
    this.cargandoTiposValidez = true;
    this.validezService.getTiposValidez(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.valideces) {
          respuesta.data.valideces.forEach((validez) => {
            this.cotizacionTiposValidez.push(<TipoValidez>{
              id: validez.id,
              descripcion: validez.descripcion
            });
          });
        }

        this.cargandoTiposValidez = false;
      },
      () => {
        this.cargandoTiposValidez = false;
      }
    );
  }

  traerImpuestos(): void {
    this.cotizacionTiposImpuesto = [];
    this.cargandoTiposImpuesto = true;
    this.impuestoService.getTiposImpuesto(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.impuestos) {
          respuesta.data.impuestos.forEach((impuesto) => {
            this.cotizacionTiposImpuesto.push(<TipoImpuesto>{
              id: impuesto.id,
              descripcion: impuesto.descripcion
            });
          });
        }

        this.cargandoTiposImpuesto = false;
      },
      () => {
        this.cargandoTiposImpuesto = false;
      }
    );
  }

  traerCondiciones(): void {
    this.condiciones = [];
    this.cargandoCondiciones = true;
    this.condicionService.getTiposCondicion(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
      {
        generico: ''
      }
    ).subscribe( // suscribimos una nueva busqueda
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.condiciones) {
          respuesta.data.condiciones.forEach(condicion => {
            this.condiciones.push(<TipoCondicion>{
              id: condicion.id,
              descripcion: condicion.descripcion
            });
          });
        }
      },
      () => {
        this.cargandoCondiciones = false;
      },
      () => {
        this.cargandoCondiciones = false;
      }
    );
  }

  onInput(): void { // cuando cambia un dato emitimos un evento
    this.onCotizacionInput.emit();
  }

  onItemsChange() { // si cambia el listado
    this.cotizacion.items = this.listadoItems.items;
    this.onInput();
  }

  compararTipoCotizacion(tipo1: any, tipo2: any): boolean | null { // le dice al select como comparar
    if (tipo1 && tipo2) {
      return tipo1.IdTipo == tipo2.IdTipo;
    }

    return false;
  }

  compararResponsable(responsable1: any, responsable2: any): boolean | null { // le dice al select como comparar
    if (responsable1 && responsable2) {
      return responsable1.IdUsuario == responsable2.IdUsuario;
    }

    return false;
  }

  compararEstado(estado1: any, estado2: any): boolean | null { // le dice al select como comparar
    if (estado1 && estado2) {
      return estado1.IdEstado == estado2.IdEstado;
    }

    return false;
  }

  compararPorId(dato1: any, dato2: any): boolean | null { // le dice al select como comparar
    if (dato1 && dato2) {
      return dato1.id == dato2.id;
    }

    return false;
  }

  onCondicionSelected(event: MatCheckboxChange, condicion: TipoCondicion): void {
    if (event.checked) {
      this.cotizacion.condiciones.push(condicion);
    } else {
      this.cotizacion.condiciones.forEach((condicionItem: TipoCondicion, index) => {
        if (condicionItem.id == condicion.id) {
          this.cotizacion.condiciones.splice(index, 1);
          return;
        }
      });
    }

    this.onInput();
  }

  onCondicionTextoInput(event: any, condicion: TipoCondicion): void {
    this.cotizacion.condiciones.forEach((condicionItem: TipoCondicion, index) => {
      if (condicionItem.id == condicion.id) {
        this.cotizacion.condiciones[index].texto = event.target.value;
        return;
      }
    });
  }

  verificandoNumero: boolean = false; // true si se está verificando el número
  numeroDisponible: boolean = true; // true si el número está disponible para está cotización
  sePudoVerificar: boolean = true; // true si se pudo verificar el número
  numeroBuscadoAlMenosUnaVez: boolean = false; // true si el número fue buscado al menos una vez (con o sin error)
  esUnEnteroPositivo: boolean = true; // true si es un número entero positivo
  esMuyLargo: boolean = false; // true si tiene más de 11 dígitos
  validarNumeroDisponible() {
    this.verificandoNumero = true;
    this.sePudoVerificar = false;
    this.esUnEnteroPositivo = this.checkNumeroEnteroPositivo(this.cotizacion.numero);
    this.esMuyLargo = this.cotizacion.numero && this.cotizacion.numero.toString().length > 7;
    if (this.cotizacion.numero && this.esUnEnteroPositivo && !this.esMuyLargo) {
      this.cotizacionService.validarNumeroDisponible(this.cotizacion).subscribe(
        respuesta => {
          if (respuesta.estado == 1) {
            if (respuesta.data) {
              this.numeroDisponible = respuesta.data.disponible;
            }

            this.sePudoVerificar = true;
          } else {
            this.sePudoVerificar = false;
          }

          this.verificandoNumero = false;
        },
        () => {
          this.verificandoNumero = false;
          this.sePudoVerificar = false;
        }
      )
    } else {
      this.verificandoNumero = false;
      this.sePudoVerificar = true;
    }

    this.numeroBuscadoAlMenosUnaVez = true;
  }

  /**
   * revisar estado del número de cotización ingresado
   * si es correcto retorna null
   */
  validarCotizacionNumero(): string | null {
    if (!this.numeroBuscadoAlMenosUnaVez) {
      return 'limpio';
    }

    if (this.verificandoNumero) {
      // estamos verificando si el número es correcto
      return 'verificando';
    }

    if (!this.sePudoVerificar) {
      // no se pudo verificar si es correcto (error en la comunicación con el server)
      return 'unchecked';
    }

    if (!this.cotizacion.numero) {
      // si no hay número se asigna automáticamente
      // siempre es correcto porque lo maneja el server
      return null;
    }

    if (!this.esUnEnteroPositivo) {
      // el número debe ser entero positivo
      return 'incorrecto';
    }

    if (this.esMuyLargo) {
      // debe ser de 7 dígitos o menos
      return 'largo';
    }

    if (!this.numeroDisponible) {
      // el número ya fue usado: volverlo a usar es una cuestión del cliente
      return 'usado';
    }

    return null;
  }

  /**
   * Retorna true si es un número entero positivo o false si no lo es
   * @param stringConNumero número para verificar
   */
  checkNumeroEnteroPositivo(stringConNumero) {
    return /^\+?(0|[1-9]\d*)$/.test(stringConNumero);
  }

  getCotizacion(): Promise<Cotizacion> {
    return new Promise<Cotizacion>((resolve, reject) => {
      // verificamos un error en los inputs
      if (this.entidadFormControl.hasError('required') ||
        this.tipoCotizacionFormControl.hasError('required') ||
        this.estadoFormControl.hasError('required') ||
        (this.validarCotizacionNumero() != null && this.validarCotizacionNumero() != 'usado' && this.validarCotizacionNumero() != 'limpio')) {
        // marcar inputs como usados para mostrar el error si es necesario
        this.entidadFormControl.markAsTouched();
        this.tipoCotizacionFormControl.markAsTouched();
        this.estadoFormControl.markAsTouched();

        throw "Datos incorrectos";
      }

      if (this.cotizacion.items.length == 0) {
        throw "Debe ingresar al menos un ítem";
      }

      // Si se requiere un permiso especial para crear/editar/copiar (ó cualquier otra acción sobre) la cotización
      if (this.requiereAutorizacionEspecial()) {
        // solicitamos al usuario el/los dato/s necesario/s para la verificación 
        let dialogAutorizar = this.dialog.open(AutorizadorDialog, {
          disableClose: true
        });

        dialogAutorizar.afterClosed().subscribe(
          autorizacion => {
            if (autorizacion) {
              // setear el campo de autorización para verificar en el servidor
              if (this.cotizacion && this.cotizacion.estado) {
                Object.assign(this.cotizacion.estado, { password: autorizacion });
              }
              //console.log(this.cotizacion);
              resolve(this.cotizacion);
            } else {
              reject("Esta acción requiere autorización");
            }
          }
        );
      } else {
        // si no requiere permisos especiales
        //console.log(this.cotizacion);
        resolve(this.cotizacion);
      }
    });
  }

  // lógica para determinar si requiere autorización especial
  requiereAutorizacionEspecial(): boolean {
    if (this.cotizacion) {
      // Si el estado es 'AUTORIZADA'
      if (this.cotizacion.estado &&
        this.cotizacion.estado.descripcion == 'AUTORIZADA') {

        // si la están creando
        if (this.IdCotizacion == null) {
          return true;
        } else {
          // si no la están creando
          if (this.cotizacion.estado.IdEstado != this.IdEstadoAnterior) {
            // si el estadó cambió (y ahora está autorizada)
            return true;
          }
        }
      }
    }

    return false;
  }
}
